define('contrato-resource',['i18n-provider', 'app-route-provider', 'notify-service'], function() {
  var app = angular.module('contrato.resource', ['i18n.provider', 'app.route.provider', 'notify.service']);
  app.factory('Contrato', ['$q', '$http', '$location', '$state', 'i18n', 'appRoute', 'notify',
    function($q, $http, $location, $state, i18n, appRoute, notify, $multipart) {
      return {
        saveSolicitacao:function(data){
          return $http.post(appRoute.linkTo('contrato.saveSolicitacao'), data);
        },
        getContratos:function(){
          return $http.get(appRoute.linkTo('contrato.getContratos'));
        },
      }
    }
  ]);
});


